const wishlistTypes = {
    ADD_TO_WISHLIST: 'ADD_TO_WISHLIST',
    REMOVE_WISHLIST_ITEM: 'REMOVE_WISHLIST_ITEM',
    CLEAR_WISHLIST: 'CLEAR_WISHLIST'
};

export default wishlistTypes;